import { localesUnderscoreMap } from "../../../../../constants/constants";
import { GetBrandedCurriculumName } from "../../../../../services/BrandingService";
import defaultCurriculumConfig, { defaultCurriculumDisplayName } from "./defaultCurriculumConfig";

/**
 * generates curriculum options based on the locale and the curriculum configured from admin
 * @param {Array} configuredCurriculum - curriculum configured from admin
 * @param {String} locale - selected data locale by teacher
 * @returns {Array} - curriculum options
 */
const getCurriculumOptions = (configuredCurriculum, locale) => {
  if(!configuredCurriculum || !locale) return [];
  const defaultCurriculum = defaultCurriculumConfig[locale];
  const curriculumByLocale = configuredCurriculum?.filter(c => c.locale === localesUnderscoreMap[locale] && c.curriculumId && c.displayName);

  // if nothing configured from admin.
  if (!curriculumByLocale || !curriculumByLocale.length) return [];

  // if default curriculum is not in the curriculumByLocale, add it.
  if (!curriculumByLocale.find(c => c.curriculumId === defaultCurriculum.curriculumId)) {
    curriculumByLocale.unshift(defaultCurriculum);
  }

  // map curriculum config to dropdown options
  return [
    ...curriculumByLocale].map(({ displayName, curriculumId, locale }) => {
      const brandedDisplayName = displayName === defaultCurriculumDisplayName ? GetBrandedCurriculumName() : displayName;
      return getCurriculumConfigToOption({ displayName: brandedDisplayName, curriculumId, locale })
    });
}

const getCurriculumConfigToOption = (curriculumConfig) => {
  console.log(curriculumConfig)
  if(!curriculumConfig) return null;
  return {
    label: curriculumConfig.displayName,
    value: curriculumConfig.curriculumId,
    locale: curriculumConfig.locale
  }
}

export { getCurriculumOptions, getCurriculumConfigToOption };